// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2zUNe","title":"Images45_title__215Vp","images":"Images45_images__3HID9"};